import { NgModule } from '@angular/core';
import { T4coreModule } from 't4core';
import { CommonModule } from '@angular/common';
import { ViewTitleComponent } from './Components/view-title/view-title.component';
import { MatDialogModule } from '@angular/material/dialog';
import { WebContentDirective } from './Directives/web-content/web-content.directive';
import { MobileContentDirective } from './Directives/mobile-content/mobile-content.directive';
import { ContentHeaderComponent } from './Components/content-header/content-header';
import { ListItemComponent } from './Components/list-item/list-item';
import { DataListComponent } from './Components/data-list/data-list';
import { AppPageBase } from './Components/appPage.base';


@NgModule({
  declarations: [
    ViewTitleComponent,
    MobileContentDirective,
    WebContentDirective,
    ContentHeaderComponent,
    ListItemComponent,
    DataListComponent
  ],
  imports: [
    T4coreModule,
    MatDialogModule,
    CommonModule
  ],
  exports: [
    ViewTitleComponent,
    MobileContentDirective,
    WebContentDirective,
    ContentHeaderComponent,
    ListItemComponent,
    DataListComponent

  ]
})
export class AppComponentsModule { }
